/**
 * CDN URL helpers for virtual-web (football3d team logos, etc.)
 */

function detectEnvironment() {
  if (typeof window === 'undefined') return 'local';
  return window.location.hostname?.includes?.('.local') ? 'local' : 'prod';
}

function getCdnDomain(env) {
  return (env || detectEnvironment()) === 'local' ? 'caribe7.local' : 'caribe7.com';
}

function getCdnProtocol(env) {
  return (env || detectEnvironment()) === 'local' ? 'http' : 'https';
}

/**
 * @param {string} teamCode - e.g. "ARS", "CHE"
 * @param {string} [env] - 'local' | 'prod'
 * @returns {string} CDN URL for the team logo
 */
export function getFootball3dTeamLogoUrl(teamCode, env) {
  if (!teamCode) return '';
  const protocol = getCdnProtocol(env);
  const domain = getCdnDomain(env);
  return `${protocol}://cdn.${domain}/assets/images/virtual-sports/football3d/teams/${teamCode}.webp`;
}

/**
 * Full CDN URL for a static asset path (e.g. no-virtual-events.png).
 * Uses production CDN (cdn.caribe7.com) for all non-local hosts; .dev is not a separate CDN.
 * @param {string} path - path under CDN, e.g. 'assets/images/virtual-sports/no-virtual-events.png'
 * @returns {string}
 */
export function getCdnAssetUrl(path) {
  const protocol = getCdnProtocol();
  const domain = getCdnDomain();
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return `${protocol}://cdn.${domain}/${normalized}`;
}
